<template>
  <v-col>
    <v-list-item-title class="list-title-name">{{user.firstName}} {{user.lastName}}</v-list-item-title>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="user.media && user.media.length && user.media[0].url"
          class="white--text ml-2"
          color="#989898"
          @click="deleteImage"
        >Delete</v-btn>
        <v-btn class="white--text mr-2" color="#FDAF19" v-on="on">Update</v-btn>
      </template>
      <v-card class="dialog-cls">
        <v-card-title class="header-title pb-4">
          Profile Picture
          <v-spacer></v-spacer>
          <v-icon color="white" @click="dialog = false">close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-5">
          <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            :destroyDropzone="false"
            :options="dropzoneOptions"
            @vdropzone-sending="beforecomplete"
            @vdropzone-success="aftercomplete"
            @vdropzone-mounted="uploadedImage"
            @vdropzone-removed-file="removeFile"
          ></vue-dropzone>
        </v-card-text>
        <v-card-actions v-if="media.length > 0" class="justify-center">
          <v-btn color="error" @click.prevent="deleteImage">
            <v-icon>mdi mdi-delete</v-icon> Remove
          </v-btn>
          <v-btn color="primary" @click="changeImage">
            <v-icon class="mdi mdi-image" /> Change
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import store from "@/store";
import { UserService } from "@/services";

export default {
  name: "UploadAvtar",
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    media: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: false,
      files: [],
      user: "",
      dropzoneOptions: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        chunking: true,
       // addRemoveLinks: true,
       //  autoProcessQueue: true,
        maxFilesize: 1,
        maxFiles: 1,
        dictFileTooBig:"File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        init() {
          this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
          this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 1) {
              // not more than 1mb
              this.removeFile(file);
            }
          });
        },
        headers: {
          Authorization: `Bearer ${store.state.user.token}`,
        },
        acceptedFiles: "image/*",
      },
    };
  },
  created() {
    this.user = this.$store.state.user.user;
  },
  methods: {
    beforecomplete(file, xhr, formData) {
      this.$refs.myVueDropzone.removeEventListeners();
      formData.append("mediaType", "image");
      formData.append("moduleType", "user");
      formData.append("mediaSubType", "file");
      formData.append("moduleId", store.state.user.user._id);
    },
    aftercomplete(file, response) {
      this.dialog = false;
      this.$refs.myVueDropzone.setupEventListeners();
      this.$emit("profileUrl", response);
      this.$store.dispatch(
        "user/setSnack",
        "Profile image uploaded successfully!"
      );
      this.$store.dispatch("user/setType", "info");
    },
    uploadedImage() {
      if (this.media && this.media.length > 0) {
        var file = {
          size: this.media[0].size,
          name: this.media[0].name,
          type: this.media[0].type,
        };
        this.$refs.myVueDropzone.manuallyAddFile(file, this.media[0].url);
      }
    },
    changeImage() {
      document.getElementById("dropzone").click();
    },
    deleteImage(){
      this.$refs.myVueDropzone.removeAllFiles();
      this.$emit("removeProfile");
      this.dialog = false;
      this.$store.dispatch(
            "user/setSnack",
            "Profile image deleted successfully!"
          );
     this.$store.dispatch("user/setType", "info");
    },
    removeFile(file) {
      if (file.size > 1024 * 1024 * 1) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 1 MB Image size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture();
    },
    async deletePicture() {
      this.media.forEach(async (media) => {
        if (!this.files.includes(media._id)) {
          this.files.push(media._id);
          const response = await UserService.removeProfileImage({
          id: media._id,
          data: {
            moduleType: "user",
            moduleId: store.state.user.user._id,
          },
        });
        if (response) {
         // this.$emit("removeProfile");
        }
      }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-title-name {
  font-size: 22px;
  padding: 8px;
  color: #344452;
  font-weight: 500;
  margin-bottom: 16px;
  padding-left: 0px;
  padding-top: 0px;
}
</style>